import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const adsClickQuery = gql`
  query AdsClick($offerId: ID!) {
    adsClick(offerId: $offerId) {
      tid
    }
  }
`

export const adsClickKey = getQueryNames(adsClickQuery)[0]

export default adsClickQuery
